export default [
  {
    path: '/escritorios',
    name: 'escritorios',
    component: () => import(/* webpackChunkName: "escritorios" */ '../../views/escritorios/Escritorios')
  },
  {
    path: '/escritorios/informacoes/:id',
    name: 'edicao-escritorio',
    component: () => import(/* webpackChunkName: "edicao-escritorio" */ '../../views/escritorios/EscritorioAdministracao')
  },
  {
    path: '/usuario/escritorios/informacoes/:id?',
    name: 'edicao-escritorio-usuario',
    component: () => import(/* webpackChunkName: "edicao-escritorio" */ '../../views/escritorios/EdicaoEscritorioUsuario')
  },
  {
    path: '/escritorios/cadastro',
    name: 'cadastro-escritorio',
    component: () => import(/* webpackChunkName: "cadastro-escritorio" */ '../../views/escritorios/CadastroAdministracao')
  },
  {
    path: '/escritorios/informacoes/:id/pedidos/:pedido',
    name: 'escritorio-detalhe-pedido',
    component: () => import(/* webpackChunkName: "escritorio-detalhe-pedido" */ '../../views/escritorios/DetalhePedido')
  }
]
